import React from 'react';
import { generatePath, useParams } from 'react-router-dom';
import ModalDialog, {
  ModalCloseHandler,
  ModalCloseReason,
} from 'src/components/ModalDialog';
import { pepApiRequest, RequestMethod, useStatefulApi } from 'src/services';
import { AlertType, useAlert } from 'src/components/AlertsProvider';
import { API_SOLUTION_USER_ITEM } from '../../constants';

type Props = {
  userId: string;
  open: boolean;
  onClose: ModalCloseHandler;
};

function SolutionUsersDeleteModal({ userId, open, onClose }: Props) {
  const { showAlert } = useAlert();
  const { solutionId } = useParams();

  const [handleRemove, loading] = useStatefulApi(
    () =>
      pepApiRequest({
        method: RequestMethod.Delete,
        url: generatePath(API_SOLUTION_USER_ITEM, {
          solutionId,
          userId,
        }),
      }),
    () => {
      showAlert({
        type: AlertType.Info,
        title: 'Unassigned solution user',
        text: 'Solution user has been unassigned.',
      });
      onClose(null, ModalCloseReason.completeAction);
    }
  );

  return (
    <ModalDialog
      open={open}
      title={`Unassign user: ${userId}`}
      text="Are you sure you want to unassign this user?"
      loading={loading}
      onClose={onClose}
      onConfirm={handleRemove}
      cancelBtnText="No"
      confirmBtnText="Yes"
    />
  );
}

export default SolutionUsersDeleteModal;
